import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    api
      .get("/public/support")
      .then((r) => setCfg(r.data))
      .catch(() => setCfg(null));
  }, []);
  if (!cfg || !cfg.whatsapp_number) return null;
  const num = cfg.whatsapp_number.replace(/[^\d]/g, "");
  const msg = encodeURIComponent(cfg.whatsapp_message || "Hello BholeBook Support");
  const href = `https://wa.me/${num}?text=${msg}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-support-btn"
      className="fixed bottom-6 right-4 lg:right-6 z-50 flex items-center gap-2 rounded-full bg-emerald-500 hover:bg-emerald-400 text-black font-display uppercase tracking-widest text-sm p-3 lg:px-5 lg:py-3 shadow-[0_10px_30px_-5px_rgba(16,185,129,0.6)] transition-colors"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden lg:inline">Support</span>
    </a>
  );
}
